import { Image, Linking, StyleSheet, Text, View } from 'react-native'
import ScreenWrapper from '@app/hoc/ScreenWrapper'
import KeyboardDismissView from '@app/hoc/KeyboardDismissView'
import { Theme, ThemedPressable, ThemedView } from '@app/theme'
import { ThemedText, ThemedTouchableOpacity } from '@app/theme/Components'
import { PrivateStackParamList } from '@app/navigationApp/types'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { addCommasToNumber } from '@app/utils'
import { usePledgeData } from '@app/hooks/usePledgeData'
import PageLoader from '@app/sharedComponents/PageLoader/PageLoader'
import Button from '@app/sharedComponents/Button/Button'
import { useState } from 'react'
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet'
import RedirectionJourneyModal from './components/RedirectionJourneyModal'
import { useTheme } from '@shopify/restyle'
import ContactUs from '../UserProfile/ContactUs'
import { useAppSelector } from '@app/store/hooks'
import Clipboard from '@react-native-clipboard/clipboard';
import CopyIcon from '../../../assets/Icons/CopyIcon'
import RightIcon from '../../../assets/Icons/Right'


//    'whatsapp://send?phone=+919611749097&text=Hi,%20I%20need%20Volt%20Money%20app%20link%20to%20complete%20my%20application

const url =
  'https://wa.me/919611749097?text=Hi,%20I%20need%20Volt%20Money%20app%20link%20to%20complete%20my%20application';


type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'REDIRECTION_JOURNEY_SCREEN'>


const RedirectionScreen = ({ route }: ScreenProps) => {

    const { pledgeData, loading: pledgeLimitLoading } = usePledgeData()
    const [modalState, setModalState] = useState<'whatsapp' | 'contact_us' | 'none'>('none')
    const { colors } = useTheme<Theme>()
    const platform = useAppSelector(state => state?.platformParams?.platform)
    const [hasCopied, setHasCopied] = useState(false);
    const isFromFlipkart = platform === 'FLIPKART'

    const handleOpenWhatsapp = () => {
        Linking.openURL(url);
    }

    const handleCopyLink = () => {
        setHasCopied(true);
		Clipboard.setString('https://voltm.app.link/get_volt_money');
    }


    if (pledgeLimitLoading) {
        return <PageLoader />
    }



    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            <KeyboardDismissView>
                <ThemedView bg='bg-surface-primary' flex={1} padding='lg'>
                    <ThemedText mt='3xl' textAlign='center' variant='h1s'>🎉</ThemedText>
                    <ThemedText textAlign='center' color='text-primary' variant='b3r'>You are ready to unlock your credit limit</ThemedText>
                    <ThemedView height={1} bg='border-secondary' mt='2xl' width={130} alignSelf='center' />
                    <ThemedText textAlign='center' color='text-primary' mt='5xl' variant='h3s'>Complete your application in just <ThemedText color='text-action-primary' variant='h3s'>5 mins!</ThemedText></ThemedText>
                    <ThemedView mb='lg' borderRadius='lg' padding='lg' mt='2xl' style={styles.card}>
                        <ThemedText color='text-primary' variant='b4r'>Your credit limit</ThemedText>
                        <ThemedView flexDirection={"row"}>
                            <ThemedText variant={"h1b"} color={"text-success"}>
                                ₹
                            </ThemedText>
                            <ThemedText variant={"h1b"} color={"text-success"}>
                                {`${addCommasToNumber(pledgeData?.stepResponseObject?.requestCreditLimit + pledgeData?.stepResponseObject?.approvedCreditLimit)}`}
                            </ThemedText>
                        </ThemedView>
                        {isFromFlipkart && (
                            <ThemedView>
                                <ThemedText color='text-primary' variant='b2b' mt='sm'>Paste this link in your browser and download Volt Money app to continue</ThemedText>
                                <ThemedTouchableOpacity onPress={handleCopyLink} mt='md' borderRadius='xs' borderWidth={1} borderColor='border-secondary' padding='sm' flexDirection='row' justifyContent='space-between' alignItems='center' style={{ gap: 10 }}>
                                    <ThemedText color='text-primary' variant='b4r'>https://voltm.app.link/get_volt_money</ThemedText>
                                    {!hasCopied ? <CopyIcon size={16} color={colors['text-action-primary']} /> : <RightIcon size={14} color={colors['text-action-primary']} />}
                                </ThemedTouchableOpacity>
                            </ThemedView>
                        )}
                    </ThemedView>
                    {!isFromFlipkart && (
                        <Button
                            label='Download Volt Money Now'
                            handlePress={() => setModalState('whatsapp')}
                        />
                    )}

                    <ThemedView flexDirection='row' justifyContent='center' alignItems='center' mt='sm'>
                        <ThemedText color='text-secondary' variant='b4r'>Available on</ThemedText>
                        <Image
                            source={{
                                uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/65f9cb6caca2c8495541c73d012ae77b679892f4dada2d8eb410c8b9d5b3b569?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                            }}
                            style={styles.image}
                        ></Image>
                        <Image
                            source={{
                                uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/0e66cbbeea02146197d456ed8115023b851967fed06fcaa956a7a7e1c74ec03d?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                            }}
                            style={styles.image}
                        />
                    </ThemedView>
                </ThemedView>

                <BottomSheetContainer
                    isVisible={modalState !== 'none'}
                    showCloseIcon={true}
                    close={() => setModalState('none')}
                    onClose={() => setModalState('none')}
                    dragComponent={<View style={{ width: 40, height: 4, backgroundColor: colors['border-primary'], borderRadius: 10 }} />}
                    containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 }}
                    closeOnBackdropPress={true}
                    borderTopRightRadius={10}
                    borderTopLeftRadius={10}
                >
                    {modalState === 'whatsapp' && <RedirectionJourneyModal onWhatsapp={handleOpenWhatsapp} onContactUs={() => setModalState('contact_us')} />}
                    {modalState === 'contact_us' && <ContactUs />}
                </BottomSheetContainer>
            </KeyboardDismissView>
        </ScreenWrapper>

    )
}

export default RedirectionScreen

const styles = StyleSheet.create({
    card: {
        boxShadow:
            '0px 20px 40px 0px rgba(12, 25, 86, 0.08)',
        borderColor: 'rgba(241, 243, 245, 1)',
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: '#FFF',
        width: '100%',
    },
    image: {
        width: 20,
        height: 20,
        marginLeft: 4,
    }
})